import { render, staticRenderFns } from "./ReportTagsList.vue?vue&type=template&id=71106040&scoped=true&"
import script from "./ReportTagsList.vue?vue&type=script&lang=js&"
export * from "./ReportTagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71106040",
  null
  
)

export default component.exports